import { render, staticRenderFns } from "./ArrowUpBold.vue?vue&type=template&id=c8764786&"
import script from "./ArrowUpBold.vue?vue&type=script&lang=js&"
export * from "./ArrowUpBold.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports